import { useEffect } from 'react';

const useInfiniteScroll = (fetchFunc: any) => {
  useEffect(() => {
    const { addEventListener, removeEventListener } = document;

    const listenerCallback = ({
      target: { scrollHeight, scrollTop, clientHeight }
    }: any) => {
      const scrollBottom = scrollHeight - scrollTop === clientHeight;

      if (!scrollBottom) {
        return;
      }

      fetchFunc();
    };

    addEventListener('scroll', listenerCallback, true);

    return () => {
      removeEventListener('scroll', listenerCallback, true);
    };
  });
};

export default useInfiniteScroll;
